// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item___0gyq","img":"Item_img__116BM","content":"Item_content__jToiX"};